// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2DNOM","noInteraction":"EventWrapper_noInteraction__1GoQr"};